import Store from 'store/store';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on('TRACK_AUTH_SUCCESS', () => {
	fire('amazon-prime-auth-success', 'membership', '-');
});

Store.on('TRACK_GET_PRIME', () => {
	fire('get-prime', 'membership', '-');
});

Store.on('TRACK_NAV_LINK_CLICK', (content) => {
	if (content?.match(/Amazon Prime/)) {
		Store.emit('TRACK_GET_PRIME');
	}
});

Store.on('TRACK_MANAGE_TICKETS', () => {
	fire('manage-tickets', 'tickets', '-');
});

Store.on('TRACK_BOOK_TICKETS', ({ theaterName, numTickets }) => {
	fire('book-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});

Store.on('TRACK_CANCEL_TICKETS', ({ theaterName, numTickets }) => {
	fire('cancel-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});

Store.on('TRACK_DOWNLOAD_TICKET', ({ theaterName, numTickets }) => {
	fire('download-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});